<template>
    <svg width="1rem" height="1rem" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1927_1517)">
            <path
                d="M2.34229 12.9892L2.34229 9.91507C2.34229 9.38218 2.77427 8.9502 3.30716 8.9502L15.6931 8.9502C16.226 8.9502 16.658 9.38218 16.658 9.91507L16.658 16.4196C16.658 16.9525 16.226 17.3845 15.6932 17.3845H3.30716C2.77428 17.3845 2.34229 16.9525 2.34229 16.4196L2.34229 15.7065"
                stroke="#F9F9F9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 14.8751L9.5 13.61" stroke="#F9F9F9" stroke-width="1.2" stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M15.2894 8.76491L15.2894 6.48246C15.2894 3.2837 12.6989 0.693237 9.50016 0.693237C6.3014 0.693237 3.71094 3.2837 3.71094 6.48246L3.71094 8.76491"
                stroke="#F9F9F9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="9.49983" cy="12.3568" r="1.34978" transform="rotate(-180 9.49983 12.3568)" fill="#F9F9F9" />
            <path
                d="M6.11865 8.76494L6.11865 6.65329C6.11865 4.79035 7.63715 3.27185 9.5001 3.27185C11.363 3.27185 12.8815 4.79035 12.8815 6.65329V8.76494"
                stroke="#F9F9F9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1927_1517">
                <rect width="18" height="18" fill="white" transform="translate(0.5 0.0449219)" />
            </clipPath>
        </defs>
    </svg>

</template>